/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AlertModule
 */

import {
    Component,
    Type,
} from '@angular/core';

import { Item } from 'ajs/modules/data-model/factories';

import {
    AviPermissionResource,
    EventId,
} from 'generated-types';

import {
    AlertConfigModalComponent,
} from 'ng/lazy-loaded-components/modals/alert-config-modal/alert-config-modal.component';

import { Alert } from 'object-types';

export const eventIdToFields = {
    [EventId.CONFIG_CREATE]: 'config_create_details',
    [EventId.CONFIG_UPDATE]: 'config_update_details',
    [EventId.CONFIG_DELETE]: 'config_delete_details',
    [EventId.USER_LOGIN]: 'config_user_login_details',
    [EventId.USER_LOGOUT]: 'config_user_logout_details',
};

/**
 * @description Item for All Alerts component
 * @author Shahab Hashmi
 */

export class AlertItem extends Item {
    constructor(args: {}) {
        const extendedArgs = {
            permissionName: AviPermissionResource.PERMISSION_ALERTCONFIG,
            objectName: 'alert',
            objectType: Alert,
            windowElement: AlertConfigModalComponent as Type<Component>,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Return the Item name this alert was generated about.
     */
    public getObjName(): string {
        const { obj_name: objName, obj_ref: objRef } = this.getConfig();

        return objName || objRef.name() || '';
    }

    /**
     * Human readable alert level enum value, such as "high", "medium" and "low".
     */
    public get level(): number {
        const { level } = this.getConfig();

        return level.slice(6).toLowerCase(); // 'ALERT_'.length
    }
}
